import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Tooltip } from 'bootstrap';
declare var $: any;
declare var bootstrap: any;

@Injectable()
export class Helpers {

  isApiUrl(req: any) {
    if (req.url.startsWith(environment.urlAPI)) {
      return true;
    }
    return false;
  }

  isSameOriginUrl(req: any) {
    // It's an absolute url with the same origin.
    if (req.url.startsWith(`${window.location.origin}/`)) {
      return true;
    }

    // It's a protocol relative url with the same origin.
    // For example: //www.example.com/api/Products
    if (req.url.startsWith(`//${window.location.host}/`)) {
      return true;
    }

    // It's a relative url like /api/Products
    if (/^\/[^\/].*/.test(req.url)) {
      return true;
    }

    // It's an absolute or protocol relative url that
    // doesn't have the same origin.
    return false;
  }

  setDataTableSearchDelay() {
    var searchDelay = null;

    setTimeout(function () {
      $('.dataTables_filter input')
        .off('keyup.DT search.DT input.DT paste.DT cut.DT')
        .on('keyup.DT search.DT input.DT paste.DT cut.DT', function (e) {
          var search = $('div.dataTables_filter input').val();
          clearTimeout(searchDelay);

          searchDelay = setTimeout(function () {
            if (search != null) {
              $.fn.dataTable.tables({ api: true, visible: true }).search(search).draw();
            }
          }, 1000);
        });
    }, 1000);
  }
  /**
    * Activa los tooltips de Bootstrap
    * Usado tras un cambio en el DOM
    * Sobre todo en los datatables
    */
  enableBsTooltips(selector: string = '[data-bs-toggle="tooltip"]'): void {
    const elements = document.querySelectorAll(selector);

    elements.forEach(el => {
      const instance = Tooltip.getInstance(el);
      if (instance) {
        instance.dispose(); // Elimina cualquier instancia anterior
      }
      new Tooltip(el);
    });
  }

  clearBsTooltips() {
    document.querySelectorAll('.tooltip').forEach(el => el.remove());
  }

  getFormData(object) {

    const formData = new FormData();

    Object.keys(object).forEach(key => {
      if (object[key] != null) {
        if (object[key].constructor.name == "Array") {

          for (let i = 0; i < object[key].length; i++) {

            if (object[key][i] instanceof Object && object[key][i].constructor.name != "File") {

              Object.keys(object[key][i]).forEach(subKey => {
                if (object[key][i][subKey] != null) {

                  let value = object[key][i][subKey];
                  if (typeof value === "number") {
                    value = value.toString();
                  }
                  formData.append(`${key}[${i}].${subKey}`, value);
                }
              });
            } else {

              let value = object[key][i];
              if (typeof value === "number") {
                value = value.toString();
              }
              formData.append(`${key}[${i}]`, value);
            }
          }
        } else if (object[key] instanceof Object && object[key].constructor.name != "File") {

          for (const subKey in object[key]) {
            if (object[key].hasOwnProperty(subKey)) {
              let value = object[key][subKey];
              if (typeof value === "number") {
                value = value.toString();
              }
              formData.append(`${key}.${subKey}`, value);
            }
          }
        } else {

          let value = object[key];
          if (typeof value === "number") {
            value = value.toString();
          }
          formData.append(key, value);
        }
      }
    });
    return formData;
  }
  formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }

  getMonths() {
    let mesesDelAnio: { value: number; label: string }[] = [
      { value: 1, label: 'Enero' },
      { value: 2, label: 'Febrero' },
      { value: 3, label: 'Marzo' },
      { value: 4, label: 'Abril' },
      { value: 5, label: 'Mayo' },
      { value: 6, label: 'Junio' },
      { value: 7, label: 'Julio' },
      { value: 8, label: 'Agosto' },
      { value: 9, label: 'Septiembre' },
      { value: 10, label: 'Octubre' },
      { value: 11, label: 'Noviembre' },
      { value: 12, label: 'Diciembre' },
    ];
    return mesesDelAnio;
  }

  /**
   * Comprueba si estamos en un entorno de desarrollo
   * Usa como referencia la URL de la API
   */
  isInDevEnvironment() {


    // It's a development local url.
    if (environment.urlAPI.startsWith('https://localhost')) {
      return true;
    }

    return false;
  }

  animateDataTable(table: HTMLElement) {
    var tableWrapper = table.closest('div.fadein-table');
    tableWrapper.classList.add('show');
  }

  groupByAndCount<T>(arr: T[], prop: keyof T): GroupedResult<T> {
    return arr.reduce((acc: GroupedResult<T>, obj: T) => {
      const key = String(obj[prop]);
      acc[key] = (acc[key] || 0) + 1;
      return acc;
    }, {});
  }

}

export interface GroupedResult<T> {
  [key: string]: number;
}
